import { Country, State, LocationFilterConfig } from '../types';

/**
 * API Configuration
 */
export const API_BASE_URL = 'https://api.countrystatecity.in/v1';
export const API_KEY = process.env.REACT_APP_COUNTRY_STATE_CITY_API_KEY;

/**
 * API headers
 */
export const getHeaders = () => ({
  'X-CSCAPI-KEY': API_KEY || '',
  'Content-Type': 'application/json',
});

/**
 * Fallback countries data for Puerto Rico and USA
 */
export const FALLBACK_COUNTRIES: Country[] = [
  {
    id: 1,
    name: 'Puerto Rico',
    iso2: 'PR',
    iso3: 'PRI',
    phone_code: '+1',
    capital: 'San Juan',
    currency: 'USD',
    currency_name: 'Dólar Estadounidense',
    currency_symbol: '$',
    tld: '.pr',
    native: 'Puerto Rico',
    region: 'Américas',
    subregion: 'Caribe',
    latitude: '18.220833',
    longitude: '-66.590149',
    emoji: '🇵🇷',
    emojiU: 'U+1F1F5 U+1F1F7'
  },
  {
    id: 2,
    name: 'Estados Unidos',
    iso2: 'US',
    iso3: 'USA',
    phone_code: '+1',
    capital: 'Washington D.C.',
    currency: 'USD',
    currency_name: 'Dólar Estadounidense',
    currency_symbol: '$',
    tld: '.us',
    native: 'Estados Unidos',
    region: 'Américas',
    subregion: 'América del Norte',
    latitude: '37.09024',
    longitude: '-95.712891',
    emoji: '🇺🇸',
    emojiU: 'U+1F1FA U+1F1F8'
  }
];

/**
 * Puerto Rico state fallback data
 */
export const PUERTO_RICO_STATE: State = {
  id: 5001,
  name: 'Puerto Rico',
  country_id: 1,
  country_code: 'PR',
  country_name: 'Puerto Rico',
  state_code: 'PR',
  iso2: 'PR',
  type: 'commonwealth',
  latitude: '18.220833',
  longitude: '-66.590149'
};

/**
 * Generic city filtering configuration
 */
export const CITY_FILTER_CONFIG: LocationFilterConfig & {
  excludeKeywords: string[];
  maxLength: number;
  minLength: number;
  excludePatterns: RegExp[];
} = {
  // Words that typically indicate neighborhoods, districts, or non-city entities
  excludeKeywords: [
    // English
    'barrio', 'neighborhood', 'district', 'sector', 'zone', 'area', 'region', 'ward', 'subdivision',
    'downtown', 'uptown', 'midtown', 'centro', 'central', 'norte', 'sur', 'este', 'oeste',
    'urban', 'urbanización', 'urb', 'residencial', 'res', 'colonia', 'col',
    // Spanish/Latin American
    'pueblo', 'aldea', 'caserío', 'parcela', 'finca', 'hacienda', 'rancho',
    'comunidad', 'desarrollo', 'conjunto', 'villa', 'reparto', 'extensión', 'ext',
    // Common subdivisions
    'phase', 'fase', 'etapa', 'section', 'sección', 'part', 'parte', 'unit', 'unidad',
    // Infrastructure/landmarks (not cities)
    'airport', 'aeropuerto', 'port', 'puerto', 'station', 'estación', 'terminal',
    'mall', 'plaza', 'center', 'hospital', 'university', 'universidad'
  ],
  
  // Length constraints
  maxLength: 35,
  minLength: 2,
  
  // Patterns that suggest non-city entries
  excludePatterns: [
    /^\d+/, // Starts with numbers
    /\d{3,}/, // Contains 3+ consecutive digits
    /^[A-Z]{2,5}$/, // All caps abbreviations (2-5 chars)
    /[()[\]{}]/, // Contains brackets or parentheses
    /\s-\s/, // Contains " - " (often indicates subdivisions)
    /\b(km|mi|mile|kilometer)\b/i, // Distance indicators
    /\b(highway|hwy|route|rt|road|rd|street|st|avenue|ave|blvd|boulevard)\b/i, // Street indicators
  ],
  
  // Required for LocationFilterConfig interface
  excludeWords: [],
  includeWords: []
};

/**
 * Popular countries (limited to Puerto Rico and USA)
 */
export const POPULAR_COUNTRIES = [
  'PR', // Puerto Rico
  'US', // United States
];
